<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Reporte Requerimientos de Compras</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
      </div>
    </div>
  </div>
</template>

<script>
import ReqCompraService from "@/services/compras/ReqCompraService";
export default {
  data() {
    return {
      /*urlPdf:
        "http://192.168.250.111:8000/api/compras/req_compra/reporte/?Id=e6c99da7-abd2-4093-aa1d-712423e9d7f6"*/
    };
  },
  components: {
  },
  mounted() {
    
  }
};
</script>
